import axios from "axios"

export const getGameByGameId = async (gameId) => {
  const base_url = process.env.VUE_APP_BASE_URL

  try {
    const gameData = await axios.get(`${base_url}/game/${gameId}`)
    return gameData.data[0];
  } catch (err) {
    console.log(err)
    throw (err)
  }
}

export const postNewGame = async (gameData) => {
  const base_url = process.env.VUE_APP_BASE_URL

  try {
    const response = await axios.post(`${base_url}/game`, gameData)
    return response.data
  } catch (err) {
    console.log(err)
    // throw (err)
    return { _id: 12939294394 }
  }
}

export const postGameLog = async (gameLog) => {
  const base_url = process.env.VUE_APP_BASE_URL

  try {
    const response = await axios.post(`${base_url}/logging`, gameLog)
    return response.data
  } catch (err) {
    console.log(err)
    return { _id: 12939294394 }
  }
}

export const putGame = async (gameData, objectId) => {
  const base_url = process.env.VUE_APP_BASE_URL

  try {
    const response = await axios.put(`${base_url}/game/objectId/${objectId}`, gameData)
    return response
  } catch (err) {
    console.log(err)
    throw (err)
  }
}

export const getPlayers = async () => {
  const base_url = process.env.VUE_APP_BASE_URL

  try {
    const response = await axios.get(`${base_url}/players`)
    return response.data;
  } catch (err) {
    console.log(err)
    throw (err)
  }
}

export const getGamesForPlayer = async (playerName) => {
  const base_url = process.env.VUE_APP_BASE_URL

  try {
    const response = await axios.get(`${base_url}/game/games-by-player/${playerName}`)
    const result = response.data.filter(g => g.fileName.startsWith("B612"))
    return result;
  } catch (err) {
    console.log(err)
    throw (err)
  }
}

export const getGamesBySet = async (fileName) => {
  const base_url = process.env.VUE_APP_BASE_URL

  try {
    const response = await axios.get(`${base_url}/game/games-by-set/${fileName}`)
    const result = response.data.filter(g =>
      g.players.some(p => p.name?.length > 0) && g.fileName.startsWith("B612")
    )
    return result;
  } catch (err) {
    console.log(err)
    throw (err)
  }
}